<nav [class.collapsed]="!sidebarOpen()" [class.theme-dark]="theme() === 'dark'" class="dashboard-menu" data-cy="side-nav" role="navigation">
    <section class="side-nav-brand p-overflow-hidden">
        <ng-container [ngTemplateOutlet]="brandLogo"></ng-container>
    </section>

    <section class="side-nav-top">
        <section class="top-nav">
            <ul id="nav-list-top" role="menu">
                @for (item of topMenu; track item; let i = $index) {
                    @if (item.visible === undefined || item.visible) {
                        <li
                            [attr.data-cy]="item.id"
                            [pTooltip]="sidebarOpen() ? '' : (item.label | translate)"
                            tooltipStyleClass="epx-tooltip"
                            role="menuitem"
                            [ngClass]="{ 'item-disabled': item.disabled, 'no-hover': item.disabled && item.isPreview }"
                            routerLinkActive="active"
                            [routerLink]="item.routerLink"
                            [id]="item.id">
                            <a class="menu-item-content" [id]="item.id">
                                <div class="menu-icon">
                                    <epx-svg-icon [size]="24" [icon]="item.svgIcon || 'sparkle'"></epx-svg-icon>
                                </div>
                                <div class="menu-label">
                                    <span>
                                        {{ item.label | translate }}
                                    </span>
                                </div>
                            </a>
                        </li>
                    }
                }
            </ul>
        </section>
    </section>
    <section class="side-nav-bottom">
        <app-epx-lang-select [sidebarOpen]="sidebarOpen()"></app-epx-lang-select>
        <section class="bottom-nav">
            <ul>
                <li [style.padding]="'0 22px'" class="flex align-items-center justify-content-end no-hover relative" id="toggle">
                    @if (sidebarOpen()) {
                        <app-app-version class="absolute" [style.left.px]="10"></app-app-version>
                    }
                    <div class="toggle-sidebar" [ngClass]="{ _expanded: sidebarOpen() }">
                        <p-button (click)="sidebarToggleEvent.emit($event)" icon="pi" rounded severity="secondary" variant="text">
                            <epx-svg-icon [icon]="sidebarOpen() ? 'chevron_left' : 'chevron_right'" [size]="28" color="Subtile"></epx-svg-icon>
                        </p-button>
                    </div>
                </li>
            </ul>
        </section>
    </section>
</nav>

<ng-template #brandLogo>
    <section class="brand-logo-wrapper">
        <svg-icon [applyClass]="true" class="brand-logo-svg" src="assets/images/brand/icons/brand-logo.svg"></svg-icon>
    </section>
</ng-template>
